"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallCreateRequestSchema = exports.CallObjectSchema = void 0;
const zod_1 = require("zod");
const artifact_1 = require("../artifact");
exports.CallObjectSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    object: zod_1.z.literal('call'),
    closed: zod_1.z.boolean(),
    thread: zod_1.z.string(),
    artifacts: artifact_1.ArtifactListResponseSchema.nullable(),
    created_at: zod_1.z.date().openapi({ format: 'date-time' }),
})
    .openapi('CallObject');
// Create
exports.CallCreateRequestSchema = zod_1.z
    .object({
    thread: zod_1.z.string(),
    tool: zod_1.z.string({ description: `The name of the tool to call` }),
    arguments: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown(), {
        description: `The arguments to pass to the tool`,
    }),
})
    .openapi('CallCreateRequest');
//# sourceMappingURL=callSchema.js.map